<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ 'sharedModule.bkgLinkReservationDialog.title' | translate }}
      </h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        attr.aria-label="{{ 'common.close' | translate }}"
      >
        <img src="assets/images/icons/close.svg" alt="" />
      </button>
    </div>

    <div class="modal__body">
      <bkg-dialog-banner
        [isVisible]="!!errorMessage"
        [message]="errorMessage"
        (closeBanner)="onCloseBanner()"
      >
      </bkg-dialog-banner>

      <div *ngIf="loadingContent" class="blue-spinner"></div>

      <div *ngIf="!showLinkRegisterForm && !logged" class="login">
        <p>
          {{ 'sharedModule.bkgLinkReservationDialog.loginText' | translate }}
        </p>

        <form *ngIf="form" [formGroup]="form" id="loginForm" errorTailor>
          <div class="form-group" [class.success]="isValidField('password')">
            <label class="sr-only">
              {{ 'sharedModule.bkgLoginDialog.password' | translate }}
            </label>
            <input
              required
              formControlName="password"
              type="password"
              id="login-password"
              placeholder="{{
                'sharedModule.bkgLinkReservationDialog.password' | translate
              }}"
              [class.warning]="hasErrors('password')"
              controlErrorsClass="info-field"
            />

            <a
              (click)="navigateToForgetYourPass()"
              class="login__forgot-pw link"
            >
              {{
                'sharedModule.bkgLinkReservationDialog.forgetPassword'
                  | translate
              }}
            </a>
          </div>

          <button
            (click)="onClickLoginLinkReservationBtn()"
            [class.disabled]="isInvalidForm"
            class="btn-primary btn-large is-block"
          >
            {{ 'sharedModule.bkgLinkReservationDialog.login' | translate }}
          </button>
        </form>
      </div>

      <div *ngIf="showLinkRegisterForm">
        <p *ngIf="showVehicleSelector || showProfileSelector || showProfileSelector">
          {{
            'sharedModule.bkgLinkReservationDialog.linkReservationText'
              | translate
          }}
        </p>
        <p *ngIf="!showVehicleSelector && !showProfileSelector && !showProfileSelector">
          {{
          'sharedModule.bkgLinkReservationDialog.linkReservationTextWithoutConfigurations'
            | translate
          }}
        </p>

        <form [formGroup]="linkForm" class="modal__section form-compact">
          <div class="form-group" *ngIf="showVehicleSelector">
            <label class="text-start">
              {{ 'sharedModule.bkgLinkReservationDialog.vehicle' | translate }}
              <div
                *ngIf="loadingVehicles"
                class="blue-spinner__small loading__spinner"
              ></div>
            </label>
            <ng-select
              #selectVehicle
              (change)="selectVehicle.blur()"
              formControlName="vehicle_id"
              [clearable]="false"
              [searchable]="false"
              placeholder="{{
                'sharedModule.bkgLinkReservationDialog.vehicle' | translate
              }}"
              controlErrorsClass="info-field--warning"
              [appendTo]="'body'"
            >
              <ng-option *ngFor="let v of userVehicles" [value]="v.id"
                >{{ v.plate }}
                {{
                  v.vehicle_information &&
                  v.vehicle_information.make_description
                    ? '- ' +
                      v.vehicle_information.make_description +
                      ' ' +
                      v.vehicle_information.model_description
                    : ''
                }}</ng-option
              >
            </ng-select>
          </div>

          <div
            class="form-group"
            *ngIf="showVehicleSelector && linkVehicleCheckbox"
          >
            <input
              type="checkbox"
              formControlName="import_vehicle"
              id="import_vehicle"
            />
            <label for="import_vehicle" class="sidebar__terms-text">{{
              'sharedModule.bkgLinkReservationDialog.importVehicle' | translate
            }}</label>
          </div>

          <div class="form-group" *ngIf="showProfileSelector">
            <label class="text-start">
              {{ 'sharedModule.bkgLinkReservationDialog.profile' | translate }}
            </label>
            <ng-select
              #selectProfile
              (change)="selectProfile.blur()"
              formControlName="profile_id"
              [clearable]="false"
              [searchable]="false"
              placeholder="{{
                'sharedModule.bkgLinkReservationDialog.profile' | translate
              }}"
              controlErrorsClass="info-field--warning"
              [appendTo]="'body'"
            >
              <ng-option
                *ngFor="let profile of userProfiles"
                [value]="profile.id"
                >{{ profile.name }}</ng-option
              >
            </ng-select>
          </div>

          <div class="form-group" *ngIf="showProfileSelector">
            <input
              type="checkbox"
              formControlName="profileCheckbox"
              id="profileCheckbox"
            />
            <label for="profileCheckbox" class="sidebar__terms-text">{{
              'sharedModule.bkgLinkReservationDialog.profileCheckbox'
                | translate
            }}</label>
          </div>

          <button
            (click)="onClickRegisterReservationBtn()"
            [class.disabled]="isInvalidLinkForm"
            class="btn-primary btn-large is-block"
          >
            {{ 'sharedModule.bkgLinkReservationDialog.importBtn' | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
